import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCsydiqx-WRVPLKbBsMFtFEojYyhe_1qJ4",
    authDomain: "sense-agro.firebaseapp.com",
    projectId: "sense-agro",
    storageBucket: "sense-agro.firebasestorage.app",
    messagingSenderId: "943413479906",
    appId: "1:943413479906:web:7fa1dd44d57af6c3d691bb"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
